<template>
  <div id="answerDetailPage">
    <router-link v-if="detail.question"  :to="{name:'IssueDetail', query:{id: detail.question.id}}" class="header">
      <div class="title">
        <i class="icon icon-wen"></i>
        <span class="name">{{detail.question.name}}</span>
      </div>
      <img class="arrow" :src="require('@/assets/images/icon_arrow_03.png')" />
    </router-link>
    <div class="section" v-if="detail.answer">
      <div class="user" v-if="detail.answer.user">
        <van-image
          class="avatar"
          :src="detail.answer.user.avatar"
          fit="cover"
          round
        ></van-image>
        <div class="info">
          <div class="name text-ellipsis">{{detail.answer.user.name}}</div>
          <div class="date">{{detail.answer.createTime | formatDate('yyyy年MM月dd日')}}</div>
        </div>
      </div>
      <div class="textarea">{{detail.answer.contentText}}</div>
      <div class="img-wrap" >
        <div class="item" v-for="(item, index) in detail.answer.contentImages" :key="index">
          <van-image @click="onImagePreview(detail.answer.contentImages, index)" class="img" :src="item" fit="cover" />
        </div>
      </div>
      <div class="record">
        <div class="item">
          <img class="icon" :src="require('@/assets/images/issue/icon_zan_01.png')" />
          <span>{{detail.answer.likes}}</span>
        </div>
        <div class="item">
          <img class="icon" :src="require('@/assets/images/issue/icon_comment_01.png')" />
          <span>{{detail.answer.comments}}</span>
        </div>
        <div class="item">
          <img class="icon" :src="require('@/assets/images/issue/icon_star_01.png')" />
          <span>{{detail.answer.followers || 0}}</span>
        </div>
      </div>
    </div>
    <div class="commtents">
      <div class="statistics" v-if="detail.answer">
        <div class="line"></div>
        <span>{{ `共${detail.answer.comments || 0}条评论` }}</span>
      </div>
      <Empty
        v-if="commentDetail.totalCount === 0"
        tip="暂无评论！"
      />
      <van-List
        v-else
        v-model="commentDetail.loading"
        :finished="commentDetail.finished"
        @load="onLoad"
      >
        <ul class="list">
          <li
            v-for="item in commentDetail.list"
            :key="item.id"
            tag="li"
            class="list-item"
          >
            <CommentItem
              :detail="item"
              @onComment="onOperate('onCommentShow', $event)"
            />
          </li>
        </ul>
        <template #finished>
          <van-divider class="list-bottom-tip">滑到底啦</van-divider>
        </template>
      </van-List>
    </div>
    <div class="footer-wrap iphoneX">
      <div class="footer">
        <div class="box">
          <div class="operation">
            <div class="item" @click="onOperate('onFollow')">
              <template v-if="detail.answer&&detail.answer.follow">
                <i class="icon icon-star-2"></i>
                <span>已关注</span>
              </template>
              <template v-else>
                <i class="icon icon-star-1"></i>
                <span>关注</span>
              </template>
            </div>
            <div class="item" @click="onOperate('onPraise')">
              <template v-if="detail.answer&&detail.answer.like">
                <i class="icon icon-zan-2"></i>
                <span>已点赞</span>
              </template>
              <template v-else>
                <i class="icon icon-zan-1"></i>
                <span>点赞</span>
              </template>
            </div>
          </div>
          <button class="btn" @click="onOperate('onCommentShow')">写下你的评论...</button>
        </div>
        <div class="iphoneX"></div>
      </div>
    </div>
    <van-popup class="popup" v-model="sendPop.show" position="bottom">
      <van-field
        ref="getFocus"
        class="message"
        :autofocus="true"
        v-model="sendPop.content"
        autosize
        type="textarea"
        placeholder="说点什么...."
      />
      <button @click="onComment">发送</button>
    </van-popup>
  </div>
</template>

<script>
import { Field } from 'vant';
import CommentItem from './components/CommentItem';
import imagePreview from '@/mixins/imagePreview.js';
export default {
  name: 'AnswerDetail',
  mixins: [imagePreview],
  components: { 'van-field': Field, CommentItem },
  data () {
    return {
      id: '',
      detail: {},
      commentDetail: {
        list: [],
        pageNo: 1,
        pageSize: 10,
        totalCount: '',
        loading: false,
        finished: false
      },
      sendPop: {
        show: false,
        detail: {},
        parentDetail: {},
        content: ''
      }
    };
  },
  mounted () {
    let { id } = this.$route.query;
    this.id = id;
    this.getDetail();
  },
  methods: {
    getDetail () {
      let { id, $http, $utils, $router } = this;
      $http.get('community/circle/answer/detail', {
        params: {
          id
        },
        showLoading: true,
        customError: true
      }).then((res) => {
        this.detail = res.data || {};
      }).catch((res) => {
        $utils.failToast({
          message: id ? res.msg : '没有该回答,页面即将返回！',
          onClose: () => {
            $router.back();
          }
        });
      });
    },
    onLoad () {
      const { commentDetail: detail, id } = this;
      this.$http.get('community/circle/answer/comment/list', {
        params: {
          id,
          pageNo: detail.pageNo,
          pageSize: detail.pageSize
        },
        hideErrorMessage: true
      }).then((res) => {
        let data = res.data.page || {};
        detail.list.push(...(data.result || []));
        detail.pageNo++;
        detail.totalCount = data.totalCount || 0;
        detail.loading = false;
        detail.finished = !data.isHasNext;
      });
    },
    onOperate (name, params) {
      if (this.$goToLogin()) {
        switch (name) {
          case 'onFollow':
            this.onFollow();
            break;
          case 'onPraise':
            this.onPraise();
            break;
          case 'onCommentShow':
            this.onCommentShow(params);
            break;
        }
      }
    },
    onFollow () {
      const { detail, id, $http } = this;
      let apiurl = detail.answer.follow ? 'community/circle/answer/unFollow' : 'community/circle/answer/follow';
      $http.post(apiurl, { id }).then((res) => {
        this.getDetail();
      });
    },
    onPraise () {
      let { id, detail, $http } = this;
      !detail.answer.like && $http.post('community/circle/answer/like', { id }).then((res) => {
        this.getDetail();
      });
    },
    onComment () {
      let { sendPop: { detail, parentDetail, content }, commentDetail, id, $http, $utils } = this;
      let subData = {
        answer: { id },
        content
      };
      if (detail.id) {
        subData.fatherComment = { id: detail.id || '' };
      }
      $http.post('community/circle/answer/comment', subData, {
        loadingText: '提交中',
        showLoading: true
      }).then((res) => {
        $utils.successToast(res.msg);
        let data = res.data;
        let { user = {} } = data;
        data = {
          ...data,
          isLike: false,
          avatar: user.avatar,
          nickname: user.nickname,
          username: user.username
        };
        if (subData.fatherComment) {
          parentDetail.details.unshift(data);
        } else {
          data.details = [];
          commentDetail.list.unshift(data);
          commentDetail.totalCount++;
          if (commentDetail.list.length >= commentDetail.pageSize && !commentDetail.finished) {
            commentDetail.list.pop();
          }
          this.sendPop.show = false;
        }
      });
    },
    onCommentShow (params = {}) {
      this.sendPop = {
        show: true,
        detail: params.detail || {},
        parentDetail: params.parentDetail || {},
        content: ''
      };
      this.$nextTick(() => {
        this.$refs.getFocus.focus();
      });
    }
  }
};
</script>

<style lang="less" scoped>
#answerDetailPage {
  padding-top: 20px;
  position: relative;
  .header {
    margin: auto;
    padding: 20px;
    width: 694px;
    background: #F7F8FC;
    border-radius: 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .title {
      font-weight: bold;
      display: flex;
      .icon {
        width: 34px;
        height: 36px;
        flex-shrink: 0;
        &.icon-wen{
          background-image: url("~@/assets/images/issue/icon_wen_02.png");
        }
      }
      .name {
        margin-left: 12px;
        font-size: 32px;
        line-height: 36px;
        color: #333444;
      }
    }
    .arrow {
      flex-shrink: 0;
      width: 32px;
      height: 32px;
      margin-left: 20px;
    }
  }
  .section {
    padding: 40px 26px;
    .user {
      display: flex;
      .avatar {
        width: 80px;
        height: 80px;
      }
      .info {
        flex: 1;
        width: 0;
        margin-left: 20px;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        .name {
          font-size: 28px;
          color: #333333;
        }
        .date {
          flex-shrink: 0;
          font-size: 24px;
          color: #999AAA;
        }
      }
    }
    .textarea {
      margin: 30px 0;
      font-size: 28px;
      color: #333444;
    }
    .img-wrap {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      .item {
        margin-bottom: 20px;
        width: 33.3%;
        display: flex;
        align-items: center;
        justify-content: center;
        .img {
          width: 218px;
          height: 166px;
          background-color: @primaryGreyBg;
          border-radius: 8px;
          overflow: hidden;
        }
      }
    }
    .record {
      margin-top: 20px;
      display: flex;
      align-items: center;
      .item {
        margin-right: 48px;
        display: flex;
        align-items: center;
        .icon {
          width: 32px;
          height: 32px;
        }
        span {
          margin-left: 8px;
          font-size: 24px;
          color: #999AAA;
        }
        .active {
          color: #F6BE64;
        }
      }
    }
  }
  .commtents {
    padding: 20px 0;
    background-color: #F7F8FA;
    .statistics {
      padding: 30px 28px;
      margin-bottom: 20px;
      background-color: #fff;
      display: flex;
      align-items: center;
      .line {
        width: 8px;
        height: 32px;
        flex-shrink: 0;
        background: #5FA9FF;
        border-radius: 4px;
      }
      span {
        margin-left: 20px;
        font-size: 28px;
        font-weight: 400;
        color: #333444;
      }
    }
  }
  .footer-wrap {
    padding-top: 100px;
    .footer {
      width: 100%;
      position: fixed;
      bottom: 0;
      left: 0;
      z-index: 999;
      box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.04);
      background-color: #fff;
      .box {
        height: 100px;
        padding-right: 28px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .operation {
          display: flex;
          .item{
            width: 110px;
            color: #333444;
            font-size: 20px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            .icon {
              width: 32px;
              height: 32px;
              &.icon-star-1{
                background-image: url("~@/assets/images/issue/icon_star_01.png");
              }
              &.icon-star-2{
                background-image: url("~@/assets/images/issue/icon_star_02.png");
              }
              &.icon-zan-1{
                background-image: url("~@/assets/images/issue/icon_zan_01.png");
              }
              &.icon-zan-2{
                background-image: url("~@/assets/images/issue/icon_zan_03.png");
              }
            }
            .name {
              line-height: 28px;
              margin-top: 4px;
            }
          }
        }
        .btn {
          width: 450px;
          height: 76px;
          font-size: 26px;
          color: #C1C1C1;
          background-color: #F6F6F6;
          text-align: left;
          border-radius: 60px;
          padding-left: 40px;
          padding-right: 40px;
        }
      }
    }
  }
  .popup {
    padding: 40px 30px;
    height: 200px;
    background: #fff;
    box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.06);
    border-radius: 20px 20px 0px 0px;
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    .message {
      flex: 1;
      height: 120px;
      margin-right: 30px;
      background: #F8F8FA;
      border-radius: 10px;
    }
    button {
      width: 112px;
      height: 48px;
      background: linear-gradient(90deg, #76DF8A 0%, #42D9A1 43%, #35D092 100%);
      border-radius: 26px;
      font-size: 26px;
      font-weight: 500;
      color: #fff;
    }
  }
}
</style>